import axios from "../services/api/api";

export function fetchTeacherCoursesAction() {
  return function (dispatch) {
    var email = localStorage.getItem("email");

    dispatch({
      type: "FETCH_TEACHER_COURSES_BEGIN",
      payload: { loading: true },
    });
    axios
      .get("/Teacher/Courses?email=" + encodeURIComponent(email))
      .then((response) => {
        dispatch({
          type: "FETCH_TEACHER_COURSES_SUCCESS",
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: "FETCH_TEACHER_COURSES_REJECTED", payload: err });
      });
  };
}
export function addCourseModuleResultSetting() {
  return function (dispatch) {};
}

export function unlockTeacherFinalExam(courseId, moduleId) {
  return async (dispatch) => {
    if (localStorage.getItem("email")) {
      await axios
        .post(
          "/Teacher/ActivateFinalExamForTeacher?email=" +
            encodeURIComponent(localStorage.getItem("email")) +
            "&courseId=" +
            courseId +
            "&moduleId=" +
            moduleId
        )
        .then((response) => {
          dispatch({
            type: "UNLOCK_TEACHER_FINALEXAM_FULFILLED",
            payload: response.data.result,
          });
        })
        .catch((err) => {
          dispatch({ type: "UNLOCK_TEACHER_FINALEXAM_REJECTED", payload: err });
        });
    }
  };
}
